import type { User } from "@/types/auth";
import { abbreviate } from "@/utils/string-utils";
import { useEffect, useMemo } from "react";

type Props = {
  user?: Pick<User, "name">;
  size?: "xs" | "sm" | "md" | "lg";
};

export function Avatar({ user, size = "sm" }: Props) {
  if (!user) throw null;

  const abbreviation = useMemo(() => abbreviate(user.name), [user.name]);
  let sizeClass: string;
  let fontSizeClass: string;

  switch (size) {
    case "lg":
      sizeClass = "size-16";
      fontSizeClass = "text-2xl";
      break;
    case "md":
      sizeClass = "size-12";
      fontSizeClass = "text-lg";
      break;
    case "sm":
    default:
      sizeClass = "size-8";
      fontSizeClass = "text-sm";
      break;
    case "xs":
      sizeClass = "size-6";
      fontSizeClass = "text-xs";
      break;
  }

  return (
    <div
      className={`flex ${sizeClass} colors-active shrink-0 items-center justify-center rounded-full transition-[color,background] duration-200`}
    >
      <span className={`${fontSizeClass} font-medium`}>{abbreviation}</span>
    </div>
  );
}
